module.exports = __webpack_public_path__ + "img/icon8.caba7fb7.png";